<script lang="ts"></script>

<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [CloseMenu]
 * Меню виджета при закрытии
 */

import { useAnalyticsEventTiModel } from "@/hooks/useAnalytics/useAnalytics";
import useStoreResetter from "@/hooks/useStoreResetter/useStoreResetter";
// Hooks
import useTranslate from "@/hooks/useTranslate/useTranslate";
// Store
import { useTIWStore } from "@/stores/tiw/tiw";
import CloseIcon from "@/ui/icons/close.vue";
import InternalIcon from "@/ui/icons/internal.vue";
// Icons
import RefreshIcon from "@/ui/icons/refresh.vue";

const TIWStore = useTIWStore();

function onRestart() {
    useStoreResetter();
    TIWStore.INJECTED_TIW.current_api.onDrop();
    TIWStore.switchStep("chooseDevice");
    useAnalyticsEventTiModel();
}

// Здесь норм
function onCancel() {
    useStoreResetter();
    TIWStore.INJECTED_TIW.current_api.onDrop();
    TIWStore.switchStep("chooseDevice");
    TIWStore.closeWidget();
}
</script>

<template>
    <div class="tiw__closeMenu">
        <ul class="tiw__closeMenu__list">
            <li class="tiw__closeMenu__item" @click="onRestart">
                <RefreshIcon class="tiw__closeMenu__icon" />
                <span class="tiw__closeMenu__text">
                    {{ useTranslate("tiw__restart") }}
                </span>
            </li>
            <li
                v-if="TIWStore.modeIsPopup && TIWStore.isCurrentStep('operatorExecuting')"
                class="tiw__closeMenu__item"
                @click="TIWStore.rollDownWidget"
            >
                <InternalIcon class="tiw__closeMenu__icon" />
                <span class="tiw__closeMenu__text">
                    {{ useTranslate("tiw__rollDown") }}
                </span>
            </li>
            <li
                v-if="TIWStore.modeIsPopup"
                class="tiw__closeMenu__item tiw__closeMenu__item_danger"
                @click="onCancel"
            >
                <CloseIcon variant="outline" class="tiw__closeMenu__icon" />
                <span class="tiw__closeMenu__text">
                    {{ useTranslate("tiw__cancel") }}
                </span>
            </li>
        </ul>
    </div>
</template>

<style lang="scss" src="./closeMenu.scss"></style>
